import React from "react";
import { FlexColumn, FlexRow, Text } from "../../../styles/Global";
import * as Global from "../../../styles/Global";
import StatBlock from "../StatBlock";
import "../../../App.scss";
import SkeletonLoader from "../../../components/SkeletonLoader";
import ScoremagicStats from "./scoremagicStats";
import ScoremagicStatsHorseshoes from "./scoremagicStatsHorseshoes";
import ScoremagicStatsAxethrowing from "./scoremagicStatsAxethrowing";

const ScoremagicStatsWrapper = ({
  sport,
  viewType,
  data,
  formatType,
  value,
}) => {
  return (
    <div style={{ width: "100%" }}>
      {data ? (
        <>
          {sport === "axethrowing" ? (
            <ScoremagicStatsAxethrowing
              viewType={viewType}
              data={data}
              formatType={formatType}
              value={value}
            />
          ) : sport === "horseshoes" ? (
            <ScoremagicStatsHorseshoes
              viewType={viewType}
              data={data}
              formatType={formatType}
              value={value}
            />
          ) : (
            <ScoremagicStats
              viewType={viewType}
              data={data}
              formatType={formatType}
              value={value}
            />
          )}
        </>
      ) : (
        <SkeletonLoader
          array={[
            { h: 50, w: "100%" },
            {
              h: 50,
              w: "100%",
              style: { marginTop: 20, borderRadius: 20 },
            },
          ]}
        />
      )}
    </div>
  );
};

export default ScoremagicStatsWrapper;
